import Vue from 'vue'
import Router from 'vue-router'
import Gyzh from '../components/caidan/gyzh.vue'
import Index from '../components/index.vue'
import Bottom from '../components/bottom.vue'
import Head from '../components/head.vue'
import Headeng from '../components/headeng.vue'
import Xwzx from '../components/caidan/xwzx.vue'
import Zszx from '../components/caidan/zszx.vue'
import Ptfw from '../components/caidan/ptfw.vue'
import Lxwm from '../components/caidan/lxwm.vue'
import Wjhg from '../components/caidan/wjhg.vue'
import newsDetail from '../components/newsDetail/index.vue'

import Zsdj from '../components/caidan/zsdj.vue'
import Gzzx from '../components/caidan/gzzx.vue'
import Gzzxeng from '../components/caidaneng/gzzx.vue'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/index', component: Index },
    { path: '/caidan/gyzh', name: 'Gyzh', component: Gyzh },
    { path: '/caidan/xwzx', name: 'Xwzx', component: Xwzx },
    { path: '/bottom', component: Bottom },
    { path: '/head', name: 'Head', component: Head },
    { path: '/headeng', name: 'Headeng', component: Headeng },
    { path: '/newsDetail/index', name: 'newsDetail', component: newsDetail },
    { path: '/caidan/zszx', component: Zszx },
    { path: '/caidan/ptfw', component: Ptfw },
    { path: '/caidan/lxwm', component: Lxwm },
    { path: '/caidan/wjhg', component: Wjhg },
    { path: '/caidan/zsdj', component: Zsdj },
    { path: '/caidan/gzzx', name: 'Gzzx', component: Gzzx },
    { path: '/caidaneng/gzzx', name: 'Gzzxeng', component: Gzzxeng },
    { path: '/', name: 'Head', component: Head }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js